uvex-tabs-accordion {
  display: block;
}
uvex-tabs-accordion.show-accordion uvex-tabs {
  display: none;
}
uvex-tabs-accordion.show-tabs uvex-accordion {
  display: none;
}
uvex-tabs-accordion uvex-tabbar {
  flex-flow: unset;
  margin: 0;
  border-bottom: 1px solid #e3e3e3;
  height: 2.5rem;
}
uvex-tabs-accordion uvex-tabbar .tab-btn {
  width: auto;
  display: inline-flex;
  height: auto;
  text-transform: unset;
  border: 1px solid transparent;
  padding: 0 1rem;
}
uvex-tabs-accordion uvex-tabbar .tab-btn.tab-btn-selected {
  border-color: #e3e3e3 #e3e3e3 transparent;
  background-color: #fff;
  color: #000000;
}
uvex-tabs-accordion uvex-tabbar a {
  margin-bottom: -1px;
}
uvex-tabs-accordion uvex-tabbar a + a {
  margin-left: 0.5rem;
}
uvex-tabs-accordion .tabs-inner {
  border: 1px solid #e3e3e3;
  border-top: 0;
  overflow: hidden;
  padding: 1rem;
}
uvex-tabs-accordion uvex-tab {
  width: 75%;
}
uvex-tabs-accordion uvex-tab h2,
uvex-tabs-accordion .collapse-content h2 {
  border-top: 0;
  margin-top: 0;
  font-size: 2rem;
}
uvex-tabs-accordion uvex-accordion-description .accordion-content {
  max-height: 100%;
  margin-bottom: 0;
}
@media (min-width: 992px) {
  uvex-tabs-accordion uvex-accordion-description .accordion-content {
    max-height: 650px;
    min-height: 650px;
  }
}
uvex-tabs-accordion uvex-accordion-description .accordion-content:after {
  height: 1rem;
}
uvex-tabs-accordion uvex-accordion-description.open .accordion-content {
  max-height: 100%;
}
@media (min-width: 992px) {
  uvex-tabs-accordion uvex-accordion-description.open .accordion-content {
    max-height: var(--max-height, 1000px);
  }
}
uvex-tabs-accordion uvex-accordion-description .plus-minus {
  display: none;
}
uvex-tabs-accordion uvex-accordion-description .btn-lg.icon-left {
  padding: 1rem 2rem 0 2rem;
  height: auto;
}
uvex-tabs-accordion uvex-accordion-description .btn-link {
  color: #000;
  font-size: 1rem;
  display: none;
}
@media (min-width: 992px) {
  uvex-tabs-accordion uvex-accordion-description .btn-link {
    display: inline-block;
  }
}
uvex-tabs-accordion uvex-accordion-description .btn.icon-left svg {
  left: auto;
  right: 0.5rem;
  top: calc(50% - 6px);
}
uvex-tabs-accordion uvex-accordion-description .chevron {
  display: block;
  transform: rotate(360deg);
  transition: transform 250ms ease-in-out;
}
uvex-tabs-accordion uvex-accordion-description.open .chevron {
  transform: rotate(180deg);
}